import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { EXPERIENCE_DATA } from '@/components/booking/bookingDefaults';

// Mirrors BookingConfigContext: merges DB-managed BookingExperience records
// over the static defaults, so admin-created / edited / deactivated experiences
// are reflected on the gift card pages. Returns an array of
// { key, name, price, tag, active, sort_order } for every active experience.
export function useBookingExperiences() {
  const { data: records = [] } = useQuery({
    queryKey: ['booking-experiences'],
    queryFn: () => base44.entities.BookingExperience.list('sort_order'),
  });

  const map = {};
  for (const [key, val] of Object.entries(EXPERIENCE_DATA)) {
    map[key] = { key, name: val.name, price: val.price, tag: val.tag, active: true, sort_order: 0 };
  }
  for (const rec of records) {
    if (rec.key && map[rec.key]) {
      map[rec.key] = { ...map[rec.key], ...rec, key: rec.key };
    }
  }

  return Object.values(map)
    .filter(e => e.active !== false)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
}